import * as React from "react";
import ReactSelect, { OptionProps as ReactSelectOptionProps } from "react-select";
import { ClearIndicator, DropdownIndicator, removeSpacesAndSpecialCharacters, SelectOption } from "../../helper";
import autocompleteStyles from "../../styles/autocompleteStyles/autocompleteStyles";
import multiSelectStyles from "../../styles/multiSelectStyles/multiSelectStyles";
import NoOptionsMessage from "../autocomplete/ui/noOptionsMessage/NoOptionsMessage";
import MultiSelectOption from "../multiSelectOption/MultiSelectOption";
import * as css from "./MultiSelectAutocomplete.scss";

export type MultiSelectAutocompleteProps = {
  inputValue: string;
  onInputChange?: (value: string) => void;
  options: Array<SelectOption>;
  selectedOptions: Array<SelectOption>;
  onSelect: (values: Array<SelectOption>) => void;
  label?: string;
  onBlur?: () => void;
  optionsLoading?: boolean;
  placeholder?: string;
  noOptionsMessage: string;
};

const MultiSelectAutocomplete: React.FC<MultiSelectAutocompleteProps> = ({
  inputValue,
  options,
  selectedOptions,
  onSelect,
  label,
  onBlur,
  onInputChange,
  optionsLoading = false,
  placeholder,
  noOptionsMessage,
}) => {
  const renderOption = (props: ReactSelectOptionProps<SelectOption, false>) => <MultiSelectOption {...props} />;

  const getNoOptionsElement: React.FC = () => {
    return (
      <NoOptionsMessage
        show
        loading={optionsLoading}
        noOptionsInfo={<div className={css.noOptionInfo}>{noOptionsMessage}</div>}
      />
    );
  };

  return (
    <>
      {label && (
        <div>
          <label className={css.label} htmlFor={`select-${label}`}>
            {label}
          </label>
        </div>
      )}
      <ReactSelect
        isMulti
        id={`select-${removeSpacesAndSpecialCharacters(label) || Math.random()}`}
        data-id="multi-select"
        components={{
          NoOptionsMessage: getNoOptionsElement,
          ClearIndicator,
          DropdownIndicator,
          Option: renderOption as React.ComponentType<ReactSelectOptionProps<SelectOption, boolean>>,
        }}
        styles={{
          ...autocompleteStyles(false, true, undefined, undefined, !!label),
          ...multiSelectStyles(),
        }}
        options={options}
        onChange={(opts) => {
          const newSelectedOptions = (opts as Array<SelectOption>) || [];
          onSelect(newSelectedOptions);
        }}
        onBlur={onBlur}
        onInputChange={(value, action) => {
          if (action.action === "input-change" && onInputChange) {
            onInputChange(value);
          }
        }}
        value={selectedOptions}
        inputValue={inputValue}
        isSearchable
        isClearable
        hideSelectedOptions={false}
        backspaceRemovesValue={false}
        closeMenuOnSelect={false}
        controlShouldRenderValue={false}
        placeholder={placeholder}
      />
    </>
  );
};

export default MultiSelectAutocomplete;
